import { createStore } from 'vuex'
import router from '@/router'

export default createStore({
  state: {
    activeCard: '#card-0',
    activeInfo: null,
    isSplashOpen: true,
    isMenuOpen: false,
    language: 'en'
  },
  getters: {
    getActiveCard(state) {
      return state.activeCard;
    },
    getActiveInfo(state) {
      return state.activeInfo;
    },
    getIsSplashOpen(state) {
      return state.isSplashOpen;
    },
    getIsMenuOpen(state) {
      return state.isMenuOpen;
    },
    getLanguage(state) {
      return state.language;
    }
  },
  mutations: {
    activeCardMutation(state, payload) {
      state.activeCard = payload;
    },
    activeInfoMutation(state, payload) {
      state.activeInfo = payload;
    },
    isSplashOpenMutation(state, payload) {
      state.isSplashOpen = !state.isSplashOpen;
    },
    isMenuOpenMutation(state, payload) {
      state.isMenuOpen = !state.isMenuOpen;
    },
    languageMutation(state, payload) {
      state.language = payload;
    }
  },
  actions: {
    activeCardAction(context, payload) {
      context.commit('activeCardMutation', payload);
    },
    activeInfoAction(context, payload) {
      context.commit('activeInfoMutation', payload);
    },
    isSplashOpenAction(context, payload) {
      context.commit('isSplashOpenMutation', payload);
    },
    isMenuOpenAction(context, payload) {
      context.commit('isMenuOpenMutation', payload);
    },
    languageAction(context, payload) {
      context.commit('languageMutation', payload);
    }
  },
  modules: {
  }
})
